import React, { useState } from 'react';
import { Modal, Button, Typography, Input, Alert } from 'antd';
import styles from './RejectFinalEditModal.module.scss';

const { Text } = Typography;
const { TextArea } = Input;

type RejectFinalEditModalProps = {
  visible: boolean;
  onBack: () => void;
  onSubmitEdits: (feedback: string) => void;
  onRequestReshoots: (feedback: string) => void;
};

const RejectFinalEditModal: React.FC<RejectFinalEditModalProps> = ({
  visible,
  onBack,
  onSubmitEdits,
  onRequestReshoots,
}) => {
  const [feedback, setFeedback] = useState('');

  const handleSubmitEdits = () => {
    onSubmitEdits(feedback);
    setFeedback('');
  };

  const handleRequestReshoots = () => {
    onRequestReshoots(feedback);
    setFeedback('');
  };

  const handleCancel = () => {
    setFeedback('');
    onBack();
  };

  const isFeedbackEmpty = feedback.trim().length === 0;

  return (
    <Modal
      title="Reject Final Edit"
      visible={visible}
      onCancel={handleCancel}
      footer={null}
      className={styles.modal}
      destroyOnClose
    >
      <div className={styles.feedbackContainer}>
        <Text className={styles.feedbackDescription}>
          Please provide feedback on the video editing. Let the talent know what
          changes are needed for the final edit.
        </Text>

        <Alert
          className={styles.alertBanner}
          type="warning"
          showIcon
          message="Note: Please provide editing feedback only. Any re-shoot requests (if needed) can be submitted in the next step."
        />

        <TextArea
          className={styles.feedbackInput}
          rows={4}
          placeholder="Enter your editing feedback..."
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        />

        <div className={styles.footer}>
          <Button
            className={styles.reshootButton}
            onClick={handleRequestReshoots}
          >
            Request Re-Shoots
          </Button>
          <Button
            type="primary"
            onClick={handleSubmitEdits}
            disabled={isFeedbackEmpty}
          >
            Submit Edits
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RejectFinalEditModal;
